/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/main/LICENSE.md for details.
 * v2.8.0
 */
/**
 * Do not edit directly
 * Generated on Wed, 01 May 2024 00:07:10 GMT
 */
const calciteSize24 = "24px";
const calciteSize32 = "32px";
const calciteSize44 = "44px";
const calciteSize48 = "48px";

export { calciteSize32 as a, calciteSize44 as b, calciteSize24 as c, calciteSize48 as d };

//# sourceMappingURL=core.js.map